import React from 'react';
import { AppRouteProps } from '~/routes';
import Create from './pages/Create';
import Index from './pages/Index';
import Edit from './pages/Edit';

export default function ResourcesFleetInspectionItems(): readonly AppRouteProps[] {
  const routes: readonly AppRouteProps[] = [
    {
      path: '/inspection-item',
      component: Index,
      isProtected: true,
      permissions: ['inspection_item_index'],
    },
    {
      path: '/inspection-item/create',
      component: Create,
      isProtected: true,
      permissions: ['inspection_item_create'],
    },
    {
      path: '/inspection-item/edit/:id',
      component: Edit,
      isProtected: true,
      permissions: ['inspection_item_edit'],
    },
  ];

  return routes;
}